<template>
  <div class="personal-accounts__items" :class="{'modal__wrapper': modal}">
    <a class="personal-accounts__link personal-accounts__link_private-clients"
       :href="`https://lk.boxberry.ru/${UTMTags}`"
       target="_blank"
       rel="noopener"
    >
      <svg class="private-clients-icon" width="20px" height="22px">
        <use xlink:href="#entity-green"></use>
      </svg>
      <span class="personal-accounts__text">Для частных клиентов</span>
    </a>
    <a class="personal-accounts__link personal-accounts__link_online-store"
       :href="hrefMobileApp"
       target="_blank"
       rel="noopener"
    >
      <svg class="online-store-icon" width="20px" height="20px">
        <use xlink:href="#icon-phone"></use>
      </svg>
      <span class="personal-accounts__text">Мобильное приложение</span>
    </a>
    <a
      class="personal-accounts__link personal-accounts__link_online-store"
      href="https://account.boxberry.ru/"
      data-utm="hide"
      target="_blank"
      rel="noopener"
    >
      <svg class="online-store-icon" width="20px" height="24px">
        <use xlink:href="#bag"></use>
      </svg>
      <span class="personal-accounts__text">Для интернет-магазинов</span>
    </a>
  </div>
</template>
<script>
import UTMTags from '../../mixins/UTMTags';

export default {
  name: 'PersonalAccountItem',
  mixins: [UTMTags],
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hrefMobileApp() {
      return this.isMobileDevice
        ? 'http://mobile.boxberry.ru/qr/?utm_source=mobile_app&utm_medium=special&utm_campaign=site&utm_term=verhnee_menu'
        : 'https://boxberry.ru/castnym-klientam/dostavka/mobil-noe-prilozenie?'
        + 'utm_source=mobile_app&utm_medium=special&utm_campaign=site&utm_term=verhnee_menu';
    },
  },
};
</script>
